// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"62120230","285":"608f021d","564":"063aea66","625":"71a10ec4","805":"d2ef21b5","807":"933259db","922":"857c865e"}[chunkId] + ".chunk.js";
};